// Live updates for the signed-in session: the session's kit holds the socket, the catch-up and the replica
// (store/kit.ts watches the core's board on it); pages that read their own data reload when the log changes their
// kinds (live/bus.ts). The mock preview runs the same kit over its sample instance (api/mock).
import { useEffect } from "react";
import { sessionKit } from "@/api";
import { useAuth } from "@/store/auth";
import { useData } from "@/store/data";
import { type KitBoard, startKitBoard } from "@/store/kit";
import { emitLive } from "./bus";

export function useLive() {
	const creds = useAuth((s) => s.creds);
	const me = useAuth((s) => s.me);
	useEffect(() => {
		if (!creds || !me) return;
		let board: KitBoard | null = null;
		let offChange: (() => void) | null = null;
		let stopped = false;
		const data = useData.getState;
		startKitBoard({
			onSnapshot: (snapshot) => data().setSnapshot(snapshot),
			onLive: (s) => {
				data().setLive(s);
				document.documentElement.dataset.live = s; // visible state for tests and debugging
			},
			onError: (error) => useData.setState({ error }),
		}).then(
			(b) => {
				if (stopped) return b.stop();
				board = b;
			},
			(e) => useData.setState({ error: `kit: ${e instanceof Error ? e.message : String(e)}` }),
		);
		void sessionKit().then((k) => {
			if (!stopped) offChange = k.onChange((kinds) => kinds.forEach((kind) => emitLive(kind, "")));
		}, () => {});
		return () => {
			stopped = true;
			board?.stop();
			offChange?.();
		};
	}, [creds?.api, creds?.instance, me?.id]);
}
